<template>
  <div class="answer-report-wrap">
    <!-- 内容区 -->
    <div class="report-cont">
      <div class="result-info-wrap">
        <div class="result-info">
          <div class="result-item accuracy" v-if="workInfo.show_accuracy === 1">
            <p>
              <span class="percent">{{ handleAccuracy }}</span>
              <span class="sign">%</span>
            </p>
            <p class="item-name">正确率</p>
          </div>
          <div class="result-item accuracy" v-else>
            <p>
              <span class="percent">{{ workInfo.score || 0 }}</span>
            </p>
            <p class="item-name">分数</p>
          </div>
          <div class="info-right-wrap">
            <div class="result-item question-num">
              <p class="num">{{ questionList.length }}</p>
              <p class="item-name">题数/道</p>
            </div>
            <div v-if="workInfo.sub_time" class="result-item total-duration">
              <p class="num">{{ handleTotalDuration.value }}</p>
              <p class="item-name">总用时/{{ handleTotalDuration.unit }}</p>
            </div>
          </div>
        </div>
        <div class="work-info">
          <p class="info-item">
            <span class="info-name">作业名称</span>
            <span class="info-value"> {{ workInfo.homework_name }}</span>
          </p>
          <p class="info-item">
            <span class="info-name">交卷时间</span>
            <span v-if="workInfo.sub_time" class="info-value">{{
              moment(workInfo.sub_time * 1000).format("YYYY-MM-DD HH:mm:ss")
            }}</span>
          </p>
        </div>
      </div>

      <div class="answer-sheet-wrap">
        <div class="title-wrap">
          <p class="title">答题卡</p>
          <ul class="round-list">
            <li class="right">
              <span class="round"></span>
              <span class="status">正确</span>
            </li>
            <li class="wrong">
              <span class="round"></span>
              <span class="status">错误</span>
            </li>
            <li class="empty">
              <span class="round"></span>
              <span class="status">未答</span>
            </li>
          </ul>
        </div>

        <ul class="number-wrap">
          <li
            @click="handleNumberClick(item)"
            class="number-item"
            v-for="(item, index) in questionList"
            :key="item.question_id"
            :class="{
              'is-answer': item.is_answer,
              'is-right': isCorrected && item.is_answer && item.is_right,
              'is-wrong': isCorrected && item.is_answer && !item.is_right,
            }"
          >
            {{ index + 1 }}
          </li>
        </ul>
      </div>
    </div>
    <!-- 底部操作区 -->
    <div class="bottom-operate-wrap">
      <button
        v-if="rightNum !== questionList.length"
        @click="showErrorAnalysis"
        class="error-analysis"
        v-preventReClick
      >
        错题解析
      </button>
      <button
        @click="showAnalysis"
        v-preventReClick
        class="all-analysis"
        :class="{
          'big-btn': rightNum === questionList.length,
        }"
      >
        全部解析
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import AnswerReport from "../mixins/answer-report.js";
export default {
  mixins: [AnswerReport],
  computed: {
    ...mapGetters("defaultHomework", ["rightNum"]),
  },
};
</script>

<style lang="scss" scoped>
.answer-report-wrap {
  height: 100%;

  .bottom-operate-wrap {
    width: 100%;
    position: fixed;
    z-index: 9;
    left: 0;
    bottom: 0.93rem;
    display: flex;
    justify-content: center;
  }
  .report-cont {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .result-info-wrap {
    position: relative;
    width: 9.17rem;
    height: 4.93rem;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 0.32rem;
    margin: 0 auto;
    padding: 0.65rem 0.32rem 0;
    &::after {
      position: absolute;
      content: "";
      width: 2.13rem;
      height: 1.84rem;
      top: 0;
      right: 0;
      background: url("../../../assets/images/homework/sheet-bg.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .result-info {
    display: flex;
    align-items: end;
    justify-content: space-between;
    padding-bottom: 0.43rem;
    border-bottom: 0.03rem solid #f2f3f5;
    padding-left: 0.37rem;
    .info-right-wrap {
      display: flex;
      align-items: end;
    }
    .item-name {
      font-weight: 400;
      font-size: 0.37rem;
      color: #4e5969;
      line-height: 0.53rem;
      white-space: nowrap;
    }
    .num {
      max-width: 2.4rem;
      font-weight: 500;
      font-size: 0.64rem;
      color: #1d2129;
      line-height: 0.77rem;
      margin-bottom: 0.05rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .percent {
      font-weight: 500;
      font-size: 1.07rem;
      color: #386bff;
      line-height: 1.28rem;
      margin-bottom: 0.05rem;
    }
    .sign {
      font-weight: 500;
      font-size: 0.45rem;
      color: #386bff;
      line-height: 0.53rem;
    }
    .accuracy {
      margin-right: 0.7rem;
    }
    .question-num {
      margin-right: 0.69rem;
    }
  }
  .work-info {
    .info-item {
      display: flex;
      margin-top: 0.32rem;
    }
    .info-name {
      font-weight: 400;
      font-size: 0.37rem;
      color: #4e5969;
      line-height: 0.53rem;
      margin-right: 0.37rem;
    }
    .info-value {
      flex: 1;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 0.37rem;
      color: #1d2129;
      line-height: 0.53rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .answer-sheet-wrap {
    flex: 1;
    width: 9.17rem;
    background: #ffffff;
    border-radius: 0.32rem;
    margin: 0.32rem auto 0;
    overflow-y: auto;

    .title-wrap {
      padding: 0.32rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        font-weight: 600;
        font-size: 0.43rem;
        color: #1d2129;
        line-height: 0.59rem;
      }
      .round-list {
        display: flex;
        align-items: center;
        li {
          display: flex;
          align-items: center;
          margin-left: 0.27rem;
        }
      }
      .round {
        width: 0.21rem;
        height: 0.21rem;
        background: #00c89d;
        border-radius: 50%;
        margin-right: 0.13rem;
      }
      .status {
        font-weight: 400;
        font-size: 0.37rem;
        color: #00c89d;
        line-height: 0.53rem;
      }
      .right {
        .round {
          background: #00c89d;
        }
        .status {
          color: #00c89d;
        }
      }
      .empty {
        .round {
          background: #c9cdd4;
        }
        .status {
          color: #86909c;
        }
      }
      .wrong {
        .round {
          background: #f76560;
        }
        .status {
          color: #f76560;
        }
      }
    }
    .number-wrap {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    .number-item {
      width: 0.8rem;
      height: 0.8rem;
      background: #f2f3f5;
      border-radius: 50%;
      font-weight: 500;
      font-size: 0.43rem;
      color: #86909c;
      line-height: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 0.37rem 0.48rem;
      &:nth-child(6n) {
        margin-right: 0;
      }
      &.is-answer {
        background: $homework-default-bg;
        color: $homework-default-color;
      }
      &.is-right {
        background: $homework-right-bg;
        color: $homework-right-color;
      }
      &.is-wrong {
        background: $homework-wrong-bg;
        color: $homework-wrong-color;
      }
    }
  }
  .error-analysis,
  .all-analysis {
    width: 4.27rem;
    height: 1.07rem;
    background: #ffffff;
    border-radius: 0.53rem;
    border: 0.03rem solid #e5e6eb;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 400;
    font-size: 0.43rem;
    color: #1d2129;
    line-height: 1;
  }
  .all-analysis {
    color: #165dff;
    border: 0.03rem solid #bedaff;
    margin-left: 0.64rem;
    &.big-btn {
      width: 9.15rem;
      margin-left: 0;
    }
  }
}
</style>
